import { intl } from "i18n/provider";
import useIsMobile from "shared/hooks/useIsMobile";

const { Toolbar, CircularProgress, Avatar } = require("@mui/material");

const SubNavItem = ({
  href,
  routeKey,
  currentRoute,
  title,
  logoSrc,
  isLoading,
  isDisabled,
  onClick,
}) => {
  const IS_MOBILE_DISPLAY = useIsMobile();
  const imageSize = IS_MOBILE_DISPLAY ? "30px" : "60px";
  return (
    <div className="my-1">
      <a
        href={href}
        onClick={(e) => {
          e.preventDefault();
          console.log(`Navigating to ${href}`);
          if (!isDisabled) onClick();
        }}
        title={isDisabled ? "يرجى إدخال رقم الجوال أولاً" : ""}
        className={`link-main ${currentRoute === routeKey ? "active-sub" : ""}`}
        style={{
          width: IS_MOBILE_DISPLAY ? "60px" : "90px",
          cursor: isDisabled ? "not-allowed" : "pointer",
          opacity: isDisabled ? 0.5 : 1,
        }}
      >
        <Toolbar
          style={{ minHeight: "initial", padding: 0, margin: 0 }}
          title={intl.formatMessage({ id: title })}
        >
          {isLoading ? (
            <CircularProgress style={{ width: imageSize, height: imageSize }} />
          ) : (
            <img
              alt=""
              src={`${logoSrc}?cb=1`}
              style={{
                height: imageSize,
                width: imageSize,
                objectFit: "cover",
                borderRadius: "50%",
                display: "inline-block",
              }}
              decoding="sync"
              loading="eager"
              crossOrigin="anonymous"
              referrerPolicy="no-referrer"
              draggable={false}
            />
          )}
        </Toolbar>
      </a>
    </div>
  );
};

export default SubNavItem;
